import type { Vec3 } from '../geo/types';
import { itemAt } from './tourPath';

/** Constrain scripted glances by travelled distance; the visitor's own look remains unrestricted. */
export function smoothTourTargets(
  positions: readonly Vec3[],
  targets: readonly Vec3[]
): readonly Vec3[] {
  const count = positions.length - 1;
  const aims = targets.slice(0, count).map((target, i) => {
    const p = itemAt(positions, i);
    const dx = target[0] - p[0],
      dy = target[1] - p[1],
      dz = target[2] - p[2];
    return { yaw: Math.atan2(dz, dx), pitch: Math.atan2(dy, Math.hypot(dx, dz)) };
  });
  let heading = itemAt(aims, 0).yaw;
  const result: Vec3[] = [];
  for (let pass = 0; pass < 3; pass++)
    for (let i = 0; i < count; i++) {
      const p = itemAt(positions, i),
        before = itemAt(positions, (i + count - 1) % count),
        aim = itemAt(aims, i);
      const turn = Math.atan2(Math.sin(aim.yaw - heading), Math.cos(aim.yaw - heading));
      const limit = 1.8 * Math.hypot(p[0] - before[0], p[2] - before[2]);
      heading += Math.max(-limit, Math.min(limit, turn));
      const range = 8 * Math.cos(aim.pitch);
      result[i] = [
        p[0] + Math.cos(heading) * range,
        p[1] + 8 * Math.sin(aim.pitch),
        p[2] + Math.sin(heading) * range,
      ];
    }
  result.push(itemAt(result, 0));
  return result;
}
